const MAPBOX_TOKEN_PLACEHOLDERS = new Set([
  'pk.YOUR_MAPBOX_TOKEN',
  'pk.YOUR_MAPBOX_PUBLIC_TOKEN',
  'pk.YOUR_PUBLIC_TOKEN',
])

export function isMapboxTokenConfigured(rawToken: string | undefined | null): boolean {
  const token = (rawToken || '').trim()
  if (!token) return false

  if (MAPBOX_TOKEN_PLACEHOLDERS.has(token)) return false

  // Guard against custom placeholder variants committed in env templates.
  if (token.includes('YOUR_MAPBOX') || token.includes('YOUR_PUBLIC_TOKEN')) {
    return false
  }

  return true
}

export function toCoordinate(
  value: unknown,
  min: number,
  max: number
): number | null {
  const parsed =
    typeof value === 'number'
      ? value
      : typeof value === 'string' && value.trim().length > 0
        ? Number(value)
        : NaN

  if (!Number.isFinite(parsed)) return null
  if (parsed < min || parsed > max) return null
  return parsed
}
